import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import TestimonialsSection from '../components/common/TestimonialsSection';
import { usePageMetadata } from '../hooks/usePageMetadata';

const Testimonials = () => {
  // Set page metadata
  usePageMetadata('testimonials');

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600">
        <div className="container mx-auto max-w-4xl text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full text-sm font-semibold text-white mb-6">
            <span>💬</span>
            Customer Stories
          </div>

          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Customer Testimonials
          </h1>

          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Discover what our customers have to say about their experiences with Diasporawise.
            Real stories from real people who have found success through our platform.
          </p>
        </div>
      </section>

      {/* Testimonials Section */}
      <TestimonialsSection
        title=""
        subtitle=""
        maxItems={12}
        showAll={true}
        className="py-16"
      />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Testimonials;
